import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// ====================================================================
// ziven-theme-aura v0.2.8 buildElements.js
// ====================================================================
//
// 共享 DOM 创建函数 (mobile drawer + desktop sidebar 复用)
// - buildUserBlock: 居中堆叠 头像+badge+名字+等级
// - buildStatsSection: 5 stats 横向 5 等分
// - buildNavSection: 6 nav (5 主体 + 1 separator + 3 账号) + 1 separator
//                   ziven-theme-aura 自己的 nav 容器, 不再 extend HeaderPrimary.items()
//
// v0.2.5: 标记当前路径所属的 nav item (左侧 4px solid 蓝灰条, 跟 ziven.ski 1:1 复刻)
// v0.2.5a: m.route.get() 优先 (跟 vendor LinkButton.isActive 1:1)
// v0.2.5b:
//   1. 后台 admin 配 defaultRoute = "/tags" 时, / 上 标签 nav active
//      (Flarum 2.0 app.routes.tags.path = "/", / 跟 /tags 都走同一个 IndexPage,
//       实际 m.route.get() === "/", 跟 nav href="/tags" 不匹配, 需要 special case)
//      修复: vendor ForumApplication.tsx 实际用 attribute('defaultRoute') (camelCase), 不是派活 spec 写的 'default_route' (snake_case)
//   2. 头像 + badges 改 vendor 原生 (跟 ziven-ski 1:1 视觉)
//      - Avatar-container (vendor class, 走 vendor 自带 .Avatar-container 样式)
//      - Avatar 走 vendor 组件 (addChunkModule chunk 170 异步注册, lazy load 后能用)
//      - badges 走 vendor listItems(user.badges().toArray()) 跟 ziven-ski 1:1
//      - 删自建 Badge--group--1/5 逻辑 (ziven-ski 1:1 不需要)
//   3. SPA 跳 /u/Ziven / /settings console 报错 防御性修 (详见 modifyDrawer.js + modifySidebar.js)
//      - 删 injectMobileSidebar() 末尾 m.redraw() (强制 sync redraw 跟 vendor 路由 redraw scheduler 死锁 / 重复)
//      - refreshNavActive() 用 setTimeout(0) 延后到 microtask (跟 vendor mithril 路由 redraw 错开, 避免在 vendor redraw 中替换 DOM 触发错误)
//      - refreshNavActive() try/catch 包 replaceWith (防御性, 实际 throw console.error 可见, 不污染 stack)
//
// 5 stats 写死占位 (辉哥 v6 拍板):
//   - 主题 4 / 积分 5 / 粉丝 0 / 关注 0 / 获赞 0
//   - 等级 1 写死
//   - TODO 注释: 装 follow/likes/points/level 扩展后改读真实数据
//
// kFormat 函数保留: 装扩展后大数自动 k 格式化 (3000→3k, 12580→12.5k)
//
// v0.2.0 改动: nav item 从 extend HeaderPrimary.items() 改为 ziven-theme-aura 自己的容器
//   - 桌面端 vendor top bar (Flarum 2.0 在 .App-drawer 内部, 跟 ziven.ski 1.8 不一样)
//   - 之前 v0.1.0c 桌面端会跟 vendor top bar 重复, 现在 nav 走 sidebar 自己的容器
//   - 跟 ziven.ski 真实 1:1 (ziven.ski sidebar 8 nav 跟 vendor top bar 不冲突)
//
// v0.2.5 标记当前路由 active 状态 (辉哥 16:04 反馈, 跟 ziven.ski 真实 1:1):
//   - ziven.ski 1.8 真实 (Playwright 调研): 当前路由对应 nav item 加 .active class
//     实际 li.border-left 从 `4px solid rgba(0, 0, 0, 0)` (透明) 变 `4px solid rgb(162, 165, 185)` (浅灰)
//   - ziven-theme-aura 实施: nav item 路径匹配时加 .active class
//     CSS: `.App-drawer-aura-nav .nav-item.active { border-left: 4px solid var(--aura-text-2); padding-left: 8px }`
//     默认 `.nav-item { border-left: 4px solid transparent; padding-left: 8px }` (占位避免 layout shift)
//   - 路径匹配规则: 精确匹配, 跟 ziven.ski 真实一致 (ziven.ski vendor ItemList.add 默认行为)
//   - 当前路径: window.location.pathname (Flarum 2.0 mithril 路由下跟 m.route.get() 一致, 但更稳定)
//
// v0.2.5b 头像 + badges 改 vendor 原生 (辉哥 18:32 反馈, 跟 ziven-ski-theme 1:1 视觉):
//   - ziven-ski-theme Sidebar.js L52-56 真实实现:
//     <div className="Avatar-container">
//       {avatar(user)}                  // vendor helper (vendor 2.0 实际未注册, mithril m() 接受 falsy 不 throw)
//       <ul className="badges">{listItems(user.badges().toArray())}</ul>
//     </div>
//   - ziven-theme-aura 实施 (改 vendor Avatar 组件代替 vendor avatar helper):
//     - 原因: vendor 2.0 dist grep 0 个 "common/helpers/avatar" 注册 (同步 add 没, addChunkModule 也没),
//       ziven-ski 1:1 follow 实际 Avatar 容器是空 div (vendor 没注册 helper, mithril 接受 undefined child 不 throw 但不渲染)
//     - 改用 vendor `flarum/common/components/Avatar` 组件 (addChunkModule chunk 170 异步注册, lazy load 后可用),
//       实际能渲染 .Avatar DOM, 跟 ziven-ski 设计意图一致 (vendor 原生 Avatar + vendor 原生 .badges)
//   - 验证: visual 上 Avatar 跟 ziven-ski Avatar 像素级一致 (都用 vendor Avatar 组件)
// ====================================================================

import app from 'flarum/common/app';
import Avatar from 'flarum/common/components/Avatar';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import LinkButton from 'flarum/common/components/LinkButton';
import listItems from 'flarum/common/helpers/listItems';
// mithril 是 vendor 注入的 window.m free variable, 不 import (跟 modifyDrawer.js m.redraw() 一致)
// 跟 ziven-ski 1:1 pattern: ziven-ski 源码 Sidebar.js 也用 free variable m (m.mount(o, J))

// v0.2.6 改读真实数据 (辉哥 20:25 反馈, 装 3 扩展后改)
//  - 主题: 暂时写死 (user.discussionCount() 等 likes 扩展装)
//  - 积分: 读 user.attribute('money') (antoinefr/flarum-ext-money v2.0.0-rc.1)
//  - 粉丝: 读 user.attribute('followerCount') (ianm/follow-users 2.0.0-beta.7, camelCase 不是 snake_case)
//  - 关注: 读 user.attribute('followingCount') (ianm/follow-users 2.0.0-beta.7, camelCase 不是 snake_case)
//  - 获赞: 暂时写死 (等 likes 扩展)
// SOP 126 教训: vendor Flarum 2.0 attribute key camelCase 不是 snake_case, 派活前必查 vendor 实际 key
const STATS = [{
  name: '主题',
  value: user => user.discussionCount() || 0
}, {
  name: '积分',
  value: user => parseFloat(user.attribute('money') || 0)
}, {
  name: '粉丝',
  value: user => parseInt(user.attribute('followerCount') || 0, 10)
}, {
  name: '关注',
  value: user => parseInt(user.attribute('followingCount') || 0, 10)
}, {
  name: '获赞',
  value: 0
}];
const LEVEL = 1;
const kFormat = n => n < 1000 ? "".concat(n) : n < 10000 ? "".concat((n / 1000).toFixed(1), "k") : "".concat(Math.round(n / 1000), "k");

// === 创建 user-block DOM (不注入, 只创建) ===
// v0.2.5b: 头像 + badges 改 vendor 原生 (跟 ziven-ski 1:1)
//   - Avatar-container (vendor class) 走 vendor 自带样式
//   - 头像用 vendor Avatar 组件 (vendor 2.0 异步 chunk 170 注册, 实际能用)
//   - badges 走 vendor listItems(user.badges().toArray()) (vendor 原生 ul.badges 样式)
//   - mithril m.render 模式: 渲染 mithril vnode 树到 real DOM 占位 div
//     不挂 mithril main app mount point, 不会被 mithril redraw 误清
export function buildUserBlock(user) {
  const userBlock = document.createElement('div');
  userBlock.className = 'App-drawer-aura-user-block';

  // 1.1 Avatar 容器 (vendor Avatar-container class, 走 vendor 自带样式)
  // ziven-ski 1:1: <div className="Avatar-container">{avatar}<ul className="badges">{listItems}</ul></div>
  const avatarWrap = document.createElement('div');
  avatarWrap.className = 'Avatar-container';
  // mithril 渲染 vendor Avatar 组件 + vendor ul.badges
  m.render(avatarWrap, [m(Avatar, {
    user
  }), m('ul', {
    className: 'badges'
  }, listItems(user.badges().toArray()))]);
  userBlock.appendChild(avatarWrap);

  // 1.2 用户名 h4
  const name = document.createElement('div');
  name.className = 'App-drawer-aura-name';
  name.textContent = user.displayName();
  userBlock.appendChild(name);

  // 1.3 等级 (写死 1)
  const level = document.createElement('div');
  level.className = 'App-drawer-aura-level';
  level.innerHTML = "\u7B49\u7EA7 <span class=\"num\">".concat(LEVEL, "</span>");
  userBlock.appendChild(level);
  return userBlock;
}

// === 创建 5 stats DOM (不注入, 只创建) ===
// v0.2.6: 接受 user 参数, 5 stats 中 1-4 项用函数形式读 user.attribute (装 3 扩展后)
//  - 主题: user.discussionCount() (vendor Flarum 原生)
//  - 积分: user.attribute('money') (antoinefr/flarum-ext-money v2.0.0-rc.1)
//  - 粉丝: user.attribute('followerCount') (ianm/follow-users 2.0.0-beta.7, camelCase)
//  - 关注: user.attribute('followingCount') (ianm/follow-users 2.0.0-beta.7, camelCase)
//  - 获赞: 写死 0 (等 likes 扩展装后再改 user.attribute('likesReceived'))
export function buildStatsSection(user) {
  const statsSection = document.createElement('div');
  statsSection.className = 'App-drawer-aura-stats';
  STATS.forEach(stat => {
    const cell = document.createElement('div');
    cell.className = 'stat-cell';
    const num = document.createElement('div');
    num.className = 'stat-num';
    // value 可能是函数 (user => ...) 或写死数字 (e.g. 获赞 0)
    const rawValue = typeof stat.value === 'function' ? stat.value(user) : stat.value;
    num.textContent = kFormat(rawValue);
    cell.appendChild(num);
    const label = document.createElement('div');
    label.className = 'stat-label';
    label.textContent = stat.name;
    cell.appendChild(label);
    statsSection.appendChild(cell);
  });
  return statsSection;
}

// === 创建 nav section (走 vendor IndexSidebar.navItems() + 路由切换时 m.render 重画) ===
// v0.2.8 (辉哥 08:50 拍板 A 方案): 走 ziven-ski 1:1 模式
//   - 主体 nav (全部主题 / 标签 / 我的关注 / etc) 走 vendor `IndexSidebar.prototype.navItems()`
//     这样装 fof-bookmarks / 任何扩展自动加 nav, 不用改 ziven-theme-aura
//   - 账号 nav (个人主页 / 设置 / 退出) ziven-theme-aura 自己加, 跟 ziven-ski Sidebar.js L108-198 sessionItems() 1:1
//   - active 状态走 vendor LinkButton.isActive 1:1 (m.route.get() 跟 href 比对)
//   - 跟 ziven-ski 1:1 一样, 接受 v0.2.5b 的 defaultRoute special case 失效
// v0.2.5 旧实现 (active 4px 蓝灰条) 已删, 改用 vendor LinkButton 自动 active
// v0.2.5b 旧实现 (defaultRoute special case) 已删, 跟 ziven-ski 1:1 接受 admin 配首页 active 不 work
// 实施: 用 mithril m.render() + 路由切换监听手动重画
//   - m.render: 一次性渲染, vendor LinkButton.isActive 一次算完写入 DOM attribute (active="true")
//   - 路由切换: ziven-theme-aura 监听 mithril 路由变化 (跟 v0.2.5b 一样的 monkey-patch pushState 机制)
//     重新 m.render 触发 LinkButton 重新 initAttrs, active attribute 重写
//   - 实际 v0.2.5b 一样机制, 只是 buildNavSection 内容改成 vendor navItems
export function buildNavSection() {
  const navSection = document.createElement('div');
  navSection.className = 'App-drawer-aura-nav';
  renderNavItems(navSection);
  return navSection;
}

// 实际渲染 nav items 到容器, 可被外部 (refreshNavActive) 重复调用
// v0.2.8 修 (重要, SOP 133 候选): 不用 m.route.get() 缓存, 主动传入 currentPath
//   - 之前用 m.render(ul, listItems(navItems.toArray())) 渲染, vendor LinkButton.initAttrs
//     在 mithril 0.2.x 异步路由切换期间调用, m.route.get() 返回旧值
//   - 修法: renderNavItems 接受 currentPath 参数, 在 vendor LinkButton 上覆盖 active 属性
//     `m(LinkButton, { href, active: currentPath === href, ... })` 强制覆盖
//   - 验证: 4 路由 (m.route.set 后) active 全部正确
// v0.2.8 hotfix3 修 (重要, 辉哥 10:45 反馈): 改 vendor "tags" priority
//   - vendor flarum-tags extend(IndexSidebar.navItems) 加 item-tags priority -10
//   - priority 最低, 排最后 (跟账号 nav 后面)
//   - 辉哥要 "标签" 跟其他 5 主体 nav 同一区域, 不要掉到底部
//   - 修法: 拿 items 后, 找到 itemName === 'tags' (vendor flarum-tags 加的), 改 priority 为 70
//     排在我的 aura-separator (50) 之前, 跟 5 主体同一区域
//   - ziven-ski 1.8 era 顺序: 全部讨论 / 消息 / Bookmarks / 我的关注 / 标签 (5 主体在同一区域)
export function renderNavItems(container, currentPath) {
  // 1. 拿 vendor + 各扩展加的 nav items (默认 IndexSidebar 只有 allDiscussions, fof-bookmarks 加 Bookmarks)
  const sidebar = new IndexSidebar();
  const navItems = sidebar.navItems();

  // 1.5 v0.2.8 hotfix3: 改 vendor "tags" priority, 排到 5 主体同一区域
  // vendor flarum-tags addTagList L14-21 add 'tags' priority -10 (最低)
  // 我们改成 70 (在 5 主体 100/90/89/? 之后, separator 50 之前)
  // (跟 ziven-ski 1.8 era 顺序一致)
  // 防御: 如果 vendor flarum-tags 没装, 'tags' key 不存在, setPriority 会 throw error (ItemList L121)
  if (navItems.has('tags')) {
    navItems.setPriority('tags', 70);
  }

  // 2. 追加 ziven-theme-aura 自己的 3 账号 nav + 1 separator (跟 ziven-ski sessionItems() 1:1)
  addAccountNavItems(navItems);

  // 1.8 v0.2.11: 1.8 1:1 复刻 1.8 ziven.ski 未登录 sidebar (辉哥 18:38 反馈 C 方案)
  // 1.8 ziven.ski 实际未登录只显示 '全部讨论' + '标签' 2 nav, 4 tag 详细 (item-tag1/2/4/5) 不渲染
  // vendor flarum-tags addTagList L44 itemName = 'tag' + tag.id() (geek.ski tags id 1/2/4/5: 滑雪技术分享/装备测评/单板/双板)
  if (!app.session.user) {
    ['tag1', 'tag2', 'tag4', 'tag5'].forEach(key => navItems.remove(key));
  }

  // 3. mithril m.render 渲染 vendor LinkButton 列表到 <ul>
  // 跟 buildUserBlock L104-107 一样 m.render 模式 (不走 mithril mount)
  // v0.2.8 修: currentPath 优先 m.route.get() 兜底
  const path = currentPath || m.route.get();
  console.log('[ziven-theme-aura] renderNavItems called, currentPath=', path, 'items=', navItems.toArray().length);
  container.innerHTML = ''; // 清空旧 DOM
  const ul = document.createElement('ul');
  container.appendChild(ul);

  // v0.2.8 修: 给 vendor LinkButton 强制覆盖 active
  // vendor LinkButton.initAttrs 看 attrs.active 有值就用, 没值才用 m.route.get()
  // 主动传 active: path === href 强制 active 正确
  // v0.2.8 修 (重要): 给 m(LinkButton, ...) 加 key (ItemList itemName, 跟 vendor listItems 行为一致)
  //   - mithril 0.2.x 限制: fragment 里的 vnode 要么都有 key 要么都没, 不然报错
  //   - vendor listItems L84-90 加 key = itemName, 我们手动 m(LinkButton) 也得加
  //   - key 用 itemName (e.g. 'allDiscussions', 'aura-profile', 'fof-bookmarks')
  const navArray = navItems.toArray();
  const itemsWithActive = navArray.map(item => {
    // item 是 mithril vnode, attrs 在 item.attrs, tag 在 item.tag
    // itemName 存在 item.itemName (ItemList.add 第二个参数 metadata)
    // 只处理 LinkButton (e.g. item-aura-profile, item-allDiscussions, item-fof-bookmarks)
    if (item && item.tag && item.tag === LinkButton && item.attrs && item.attrs.href) {
      var _item$attrs$href;
      return m(LinkButton, _objectSpread(_objectSpread({
        key: item.itemName || item.attrs.key
      }, item.attrs), {}, {
        active: (path == null ? void 0 : path.split('?')[0]) === ((_item$attrs$href = item.attrs.href) == null ? void 0 : _item$attrs$href.split('?')[0])
      }), item.children);
    }
    return item;
  });
  m.render(ul, listItems(itemsWithActive));
}

// === 追加 3 账号 nav + 1 separator 到 vendor navItems (跟 ziven-ski sessionItems() 1:1) ===
// 主体 5 nav 走 vendor, 这 3 账号 + 1 separator ziven-theme-aura 自己管
function addAccountNavItems(navItems) {
  const user = app.session.user;
  if (!user) return;

  // separator (在 vendor nav 跟账号 nav 之间, 跟 ziven-ski 1.8 sessionItems L113 separator 1:1)
  navItems.add('aura-separator', m('li', {
    className: 'App-drawer-aura-nav-separator'
  }), 50);

  // 个人主页 (跟 ziven-ski sessionItems L116-125 1:1)
  navItems.add('aura-profile', m(LinkButton, {
    icon: 'fas fa-user',
    href: app.route('user', {
      username: user.username()
    })
  }, app.translator.trans('core.forum.header.profile_button')), 40);

  // 设置 (跟 ziven-ski sessionItems L128-136 1:1)
  navItems.add('aura-settings', m(LinkButton, {
    icon: 'fas fa-cog',
    href: app.route('settings')
  }, app.translator.trans('core.forum.header.settings_button')), 30);

  // 退出 (跟 ziven-ski sessionItems L158-168 1:1, 用 LinkButton 不用 Button, 因为 logout 是 link 不是 button action)
  navItems.add('aura-logout', m(LinkButton, {
    icon: 'fas fa-sign-out-alt',
    onclick: e => {
      e.preventDefault();
      app.session.signOut();
    }
  }, app.translator.trans('core.forum.header.log_out_button')), 10);
}